module.exports = __webpack_public_path__ + "static/media/Security_Camera_In_Use.2f19543d.png";